import styled from '@emotion/styled'

const FormContainer = styled.div`
    width: ${({ fullwidth }) => (fullwidth ? '100%' : '80%')};
`

export { FormContainer }
